import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockConfirmationModal', {
  warning: '¿Estás seguro que deseas desbloquear el ingrediente: ',
  unblock: 'Desbloquear producto',
  success: '¡Producto/ingrediente bloqueado correctamente!',
  failure: 'Ocurrió un error y no se pudo bloquear el producto, intenta de nuevo'
});

i18next.addResources('es_CR', 'BlockConfirmationModal', {
  warning: '¿Estás seguro que deseas desbloquear el ingrediente: ',
  unblock: 'Desbloquear producto',
  success: '¡Producto/ingrediente bloqueado correctamente!',
  failure: 'Ocurrió un error y no se pudo bloquear el producto, intenta de nuevo'
});
